export default "__VITE_ASSET__CLo_pqab__"